import {
  useRoomCreate,
  useRoomDelete,
  useRoomGet,
  useRoomGetSuspense,
  useRoomList,
  useRoomListSuspense,
  useRoomUpdate,
} from "@/api/generated/endpoints/api"
import {
  roomCreateBody,
  roomGetParams,
  roomGetQueryParams,
  roomListQueryParams,
  roomUpdateBody,
} from "@/api/generated/schemas/api.zod"

export * as RoomModels from "./models"

export const roomApi = {
  // Query Hooks
  useRoomList,
  useRoomListSuspense,
  useRoomGet,
  useRoomGetSuspense,

  // Mutation Hooks
  useRoomCreate,
  useRoomUpdate,
  useRoomDelete,
}

export const roomSchemas = {
  roomCreateBody,
  roomUpdateBody,
  roomGetParams,
  roomGetQueryParams,
  roomListQueryParams,
}
